export const POLLING_INTERVAL = 5 * 1000;
export const TARIFFS_EXTERNAL_ID = "web 2";
